import type { FC, ReactNode } from "react";

import { useBreakpoints } from "@shared/hooks";

import * as styles from "./AuthHeaderWrapper.styles";

interface Props {
  children: ReactNode;
  includeBorder?: boolean;
}

const AuthHeaderWrapper: FC<Props> = ({ children, includeBorder }) => {
  const { tablet } = useBreakpoints();

  return (
    <div css={[styles.wrapper, includeBorder && tablet.greaterThan && styles.bottomBorder]}>
      {children}
    </div>
  );
};

export { AuthHeaderWrapper };
